import React from 'react';
// import { useTheme } from '@mui/material';

// <Box
//     key={keyIndex}
//     sx={{
//         textAlign: 'center',
//         backgroundColor: theme.palette.primary.main,
//         margin: 0,
//         padding: 1,
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         flexDirection: 'column',
//         ...rest
//     }}>
//     <h1 style={{ color: theme.palette.common.white, fontSize: isMediumScreen ? theme.typography.fontSize : theme.typography.fontSize * 3, fontWeight: 'bold' }}>
//         🎉¡Vitti Logistics te desea Feliz Cumpleaños!🎂
//     </h1>
//     <Box
//         sx={{
//             background: theme.palette.common.white,
//             padding: 1,
//             borderRadius: 2,
//             mb: 2,
//             maxWidth: '70%',
//             color: theme.palette.primary.main,
//             position: 'relative',
//             width: '100%',
//         }}>
//         <Box p={1}>
//             <Stack direction="column" alignItems="center" mb={2}>
//                 <Avatar src={userData.file} sx={{ height: isMediumScreen ? '70px' : '100px', width: isMediumScreen ? '70px' : '100px', ml: 1, }} />
//                 <Typography variant="body1" color="primary" fontWeight="bold" className="ml-1">
//                     {userData.user_full_name}
//                 </Typography>
//                 <Typography variant="body2" color="primary" className="ml-1">
//                     {userData.birthday_date}
//                 </Typography>
//             </Stack>
//         </Box>
//         <Typography variant={isMediumScreen ? 'body2' : 'h6'} color="primary" fontWeight="bold">
//             En este día especial, queremos felicitarte y agradecerte por tu esfuerzo y dedicación.
//             Esperamos que este nuevo año de vida esté lleno de grandes logros, alegría y momentos inolvidables junto a tus seres queridos.
//             ¡Disfruta tu día al máximo!
//         </Typography>
//         <Typography variant={isMediumScreen ? 'body2' : 'h5'} color="primary" fontWeight="bold" mt={2}>Atentamente.</Typography>
//         <img
//             src={VittiLogisticLogo}
//             alt="Vitti Logistic"
//             style={{ marginTop: theme.shape.margin * 2, width: isMediumScreen ? '100%' : '50%', }}
//         />
//     </Box>
// </Box>

const HappyBirthday = ({ keyIndex, userData, isMediumScreen, ...rest }) => {
    // const theme = useTheme();
    // console.log(userData)

    return (
        <div style={{ width: "100%", minHeight: '100%', textAlign: "center", position: "relative", display: "flex", flexDirection: "column", alignItems: "center", background: 'rgba(0,0,0,.1)', padding: 20 }}>
            <img src={userData.file} alt="" style={{ maxWidth: 157, maxHeight:157, margin: "auto", borderRadius: 1000, position: 'absolute', top: 145 }} />
            <div style={{ display: 'flex', gap: 10, position: 'absolute', top: 480, color: 'white', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                <h3 style={{margin: 0}}>{userData.user_full_name}</h3>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <p style={{margin: 0}}>{userData.position}</p>
                    <p style={{margin: 0}}>{userData.birthday_date}</p>
                </div>
            </div>
            <img src="/birthday_base.png" alt="" style={{ maxWidth: 600, margin: "auto", borderRadius: 10 }} />
        </div>
    )
};

export default HappyBirthday;